import { render, staticRenderFns } from "./RegistrationHome.vue?vue&type=template&id=a81e2862&scoped=true&"
import script from "./RegistrationHome.vue?vue&type=script&lang=js&"
export * from "./RegistrationHome.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationHome.vue?vue&type=style&index=0&id=a81e2862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81e2862",
  null
  
)

export default component.exports